import { MouseEvent } from 'react';

/*
  This utility function checks if the provided MouseEvent is a valid click event.

  In react, when a radio is checked using keyboard accessibility, a click event is triggered.
  see: https://github.com/facebook/react/issues/7407

  This is useful on pages where we submit the form upon initial selection of a radio option. Due to react 
  triggering a click event when keyboard accessibility is used, the form is submitted unintendedly.
*/
export const isValidClickEvent = (event: MouseEvent<unknown>): boolean => {
  return event.type === 'click' && event.clientX !== 0 && event.clientY !== 0;
};
